import { render, staticRenderFns } from "./BankCardGroupEdit.vue?vue&type=template&id=b38f157e&scoped=true&"
import script from "./BankCardGroupEdit.vue?vue&type=script&lang=js&"
export * from "./BankCardGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankCardGroupEdit.vue?vue&type=style&index=0&id=b38f157e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38f157e",
  null
  
)

export default component.exports